"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _dropdownChevronMixin = require("../dropdownChevronMixin");
var _spaceMixin = require("../spaceMixin");
var _InputMixin = require("./InputMixin");
/** @class SelectMixin */
/** @method */
var SelectMixin = function SelectMixin(props) {
  return (0, _styledToken.default)('Select.chevronWidth', function (chevronWidth) {
    return (0, _styledComponents.css)(["", " ", " appearance:none;padding-right:", "px;&:not(:disabled){cursor:pointer;}&::-ms-expand{display:none;}"], (0, _InputMixin.InputMixin)(props), !props.readOnly ? (0, _dropdownChevronMixin.dropdownChevronMixin)(props) : null, (0, _spaceMixin.spaceMixin)('xs', function (space) {
      return space.value + chevronWidth;
    })(props));
  })(props);
};
exports.SelectMixin = SelectMixin;